import React from 'react';

const TheLevelLogo = () => {
  return (
    <svg
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      data-testid="theEcoExpertsLogo"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2,
      }}
      width="100%"
      height="100%"
      viewBox="0 0 200 50"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        id="Artboard1"
        x="0"
        y="0"
        width="200"
        height="50"
        style={{ fill: 'none' }}
      />
      <g id="Artboard1">
        <g transform="matrix(0.607755,0,0,0.607755,24.9149,0)">
          <path
            d="M0,22.43L17.41,22.43L17.41,69.19L39.5,69.19L39.5,82.17L0,82.17L0,22.43Z"
            style={{ fillRule: 'nonzero' }}
          />
          <path
            d="M45.31,22.43L85.94,22.43L84.49,35.33L62.72,35.33L62.72,45.01L79.97,45.01L79.97,57.91L62.72,57.91L62.72,69.28L86.42,69.28L86.42,82.18L45.31,82.18L45.31,22.43Z"
            style={{ fillRule: 'nonzero' }}
          />
          <path
            d="M159.7,22.43L200.33,22.43L198.88,35.33L177.11,35.33L177.11,45.01L194.36,45.01L194.36,57.91L177.11,57.91L177.11,69.28L200.81,69.28L200.81,82.18L159.7,82.18L159.7,22.43Z"
            style={{ fillRule: 'nonzero' }}
          />
          <path
            d="M207.58,22.43L225,22.43L225,69.19L247.09,69.19L247.09,82.17L207.58,82.17L207.58,22.43Z"
            style={{ fillRule: 'nonzero' }}
          />
        </g>
        <g transform="matrix(0.607755,0,0,0.607755,24.9149,0)">
          <path
            d="M4.49,4.61L0,4.61L0,1.03L13.77,1.03L13.77,4.61L9.29,4.61L9.29,17.49L4.49,17.49L4.49,4.61Z"
            style={{ fillRule: 'nonzero' }}
          />
          <path
            d="M15.42,1.03L20.22,1.03L20.22,6.9L24.53,6.9L24.53,1.03L29.33,1.03L29.33,17.49L24.53,17.49L24.53,10.67L20.22,10.67L20.22,17.49L15.42,17.49L15.42,1.03Z"
            style={{ fillRule: 'nonzero' }}
          />
          <path
            d="M31.94,1.03L43.14,1.03L42.74,4.58L36.74,4.58L36.74,7.25L41.49,7.25L41.49,10.8L36.74,10.8L36.74,13.93L43.27,13.93L43.27,17.48L31.94,17.48L31.94,1.03Z"
            style={{ fillRule: 'nonzero' }}
          />
        </g>
        <g transform="matrix(0.607755,0,0,0.607755,24.9149,0)">
          <path
            d="M128.49,82.27L110.85,82.27L88.83,21.77L106.47,21.77L128.49,82.27Z"
            style={{ fill: 'rgb(255,196,29)', fillRule: 'nonzero' }}
          />
          <path
            d="M123.82,60.5L141.46,60.5L163.48,0L145.84,0L123.82,60.5Z"
            style={{ fill: 'rgb(255,196,29)', fillRule: 'nonzero' }}
          />
        </g>
      </g>
    </svg>
  );
};

export default TheLevelLogo;
